import { useCallback, useEffect, useState } from "react";

import * as Pool from "../api/chain/pool";

import Store from "../../../stores/store";
import Web3 from "web3";
import { GET_STAKING_POOLS_INFO } from "../../../constants/constants";
import { useAccount } from "../../../contexts/AccountContext";

const store = Store.store;
const dispatcher = Store.dispatcher;

export const useVesting = () => {
  const { account } = useAccount();

  const [vestings, setVestings] = useState({});
  const [isLoading, setLoading] = useState(true);

  const burnFee = store.getStore("burnFee");
  const lastInvestTimestamp = store.getStore("lastInvestTimestamp");
  const lastUnstakedTime = store.getStore("lastUnstakedTime");

  const getVestingReturned = useCallback(() => {
    const vestingPools = store.getStore("vestings");

    setVestings(vestingPools);
    setLoading(false);
  }, []);

  useEffect(() => {
    getVestingReturned();

    const watchVestingChangeId = setInterval(() => {
      getVestingReturned();
    }, 1000);

    return () => {
      clearInterval(watchVestingChangeId);
    };
  }, [getVestingReturned]);

  const unstake = useCallback(
    async (pool, depositId, amount) => {
      const web3 = new Web3(store.getStore("web3context").library.provider);

      await Pool.unstake(web3, pool.pool, depositId, amount, account.address);
      dispatcher.dispatch({ type: GET_STAKING_POOLS_INFO, content: {} });
    },
    [account]
  );

  return {
    vestings,
    isLoading,
    unstake,
    burnFee,
    lastInvestTimestamp,
    lastUnstakedTime,
  };
};
